import axios from 'axios';
import qs from 'qs';
const Mustache = require('mustache');
class Exceed {
    constructor(config) {
        config = config || {};
        const finalConfig = config;
        finalConfig.ENV = finalConfig.ENV || 'production';
        finalConfig.validateStatus = finalConfig.validateStatus || function (status) {
            return (status >= 200 && status < 300) || status === 401 || status === 400;
        };
        // 组合为最终配置
        this.config = finalConfig;
        this.apimap = [];
        this.axios = axios.create({
            timeout: finalConfig.timeout || 3000,
            withCredentials: true,
            validateStatus: finalConfig.validateStatus,
        });
        this.interceptors = this.axios.interceptors;
    }
    use(apimap) {
        if (apimap instanceof Array) {
            this.apimap = apimap;
        }
        else {
            console && console.warn && console.warn(`can not found ENV:${this.config.ENV} in your apimap`);
        }
    }
    fetch(param) {
        let requestParams;
        if (typeof param === 'string') {
            param = {
                api: param,
            };
        }
        this.apimap.forEach((item) => {
            const localItem = Object.assign({}, item);
            if (item.id === param.api) {
                // 如果存在 params 字段则调用胡子插件进行字符串模板渲染
                if (param.params) {
                    const url = item.urls[this.config.ENV];
                    localItem.url = Mustache.render(url, param.params);
                }
                else {
                    localItem.url = item.urls[this.config.ENV];
                }
                requestParams = localItem;
            }
        });
        if (!requestParams) {
            console && console.warn && console.warn(`can not found API:${param.api} in your current environment`);
        }
        // 添加通用参数
        if (!requestParams.url) {
            console.warn('API url is null, please check the APIMAP');
        }
        // 将访问数据添加进requestParams中
        if (param.data) {
            requestParams.data = param.data;
        }
        requestParams.data = requestParams.data || {};
        if (requestParams.method === 'get' || requestParams.method === 'GET') {
            const arr = Object.keys(requestParams.data);
            arr.forEach((item, index) => {
                if (index === 0 && requestParams.url.indexOf('?') === -1) {
                    requestParams.url += `?${item}=${requestParams.data[item]}`;
                }
                else {
                    requestParams.url += `&${item}=${requestParams.data[item]}`;
                }
            });
        }
        if (requestParams.url.indexOf('?') === -1) {
            requestParams.url += '?';
        }
        else {
            requestParams.url += '&';
        }
        requestParams.url += '_input_charset=utf-8';
        requestParams.headers = Object.assign({}, requestParams.headers, {
            'content-type': requestParams.contentType,
        });
        if (requestParams.contentType === 'application/x-www-form-urlencoded') {
            if (requestParams.qsOptions) {
                requestParams.data = qs.stringify(requestParams.data, requestParams.qsOptions);
            }
            else {
                requestParams.data = qs.stringify(requestParams.data);
            }
        }
        return this.axios.request(requestParams);
    }
}
export default Exceed;
